export default __webpack_public_path__ + "1566cc62c6f0c0d34c1d12865420e379.png";